import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  Typography, Stack, Button as MuiButton,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { startSetSignupIntent } from '@client/slices/helpers/session.reducer';
import { useDispatch } from '@client/hooks/redux.hooks';
import { SignupIntents } from '@sda/enums';
import { baseUrl } from '@sda/utils/url';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { SignupWrapper } from './common/SignupWrapper';

const useStyles = makeStyles()((theme) => ({
  extraSpacing: {
    marginBottom: theme.spacing(3),
  },
}));

const Explainer = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const handleProfileButtonClick = useCallback((intent: SignupIntents) => {
    dispatch(startSetSignupIntent(intent));
  }, [dispatch]);

  return (
    <>
      <Typography
        variant="h6"
        className={classes.extraSpacing}
        align="left"
        component="p"
      >
        Which role best describes you?
      </Typography>

      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={2}
      >
        <MuiButton
          component={Link}
          to="/signup/artist"
          color="primary"
          variant="contained"
          size="large"
          onClick={() => handleProfileButtonClick(SignupIntents.ARTIST)}
          fullWidth={isMobile}
        >
          I'm an Artist
        </MuiButton>

        <MuiButton
          component={Link}
          to="/signup/host"
          color="primary"
          variant="contained"
          size="large"
          onClick={() => handleProfileButtonClick(SignupIntents.VENUE)}
          fullWidth={isMobile}
        >
          I'm a Host
        </MuiButton>

        <MuiButton
          component={Link}
          to="/shows"
          color="primary"
          variant="outlined"
          size="large"
          onClick={() => handleProfileButtonClick(SignupIntents.AUDIENCE)}
          fullWidth={isMobile}
        >
          I'm in the audience
        </MuiButton>
      </Stack>
    </>
  );
};

export const Intent = () => (
  <SignupWrapper
    renderExplainer={<Explainer />}
    imgSrc={baseUrl('media/signup/sidedoorcrop-sapphicsounds.jpg')}
    imgTitle="Sug Daniels at Drea's Place. Photo: Casey Owens."
    displayImageOnMobile
  />
);
